import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { DEFAULT_LATEST, THIS_MONTH, TODAY } from 'constants/dateLimits';
import { getSafeDateTime, isSafeDateLater, setToStartOfMonth } from 'helpers/date';
import { SafeDateTime } from 'helpers/types';
import { SubstanceDrugsNegativeImpactModel } from './types';

const substanceDrugsNegativeImpactValidator: ValidateJSModel<SubstanceDrugsNegativeImpactModel> = {
  HasNegativeImpact: { presence: true, hasValue: { validator: hasYesOrNo } },
  NegativeImpactDates: (value, attributes, attributeName, options) => {
    if (attributes?.HasNegativeImpact?.value !== 'Yes') {
      return {};
    }

    if (!options?.applicantBirthdate) { return {}; }
    if (!value?.to) { return { presence: true }; }
    const applicantBirthdate: SafeDateTime = getSafeDateTime(options?.applicantBirthdate);
    const endDate: SafeDateTime = getSafeDateTime(value.to);
    const sixteenthBirthdate: SafeDateTime = getSafeDateTime(applicantBirthdate?.datetime?.plus({ years: 16 }));
    const twentyFirstBirthday: SafeDateTime = getSafeDateTime(applicantBirthdate?.datetime?.plus({ years: 21 }));
    const fiveYearsAgo: SafeDateTime = getSafeDateTime(DEFAULT_LATEST.minus({ years: 5 }));

    // if 21 bday is before (or on) today applicant is over 21
    const isOverTwentyOne: boolean = isSafeDateLater(getSafeDateTime(DEFAULT_LATEST), twentyFirstBirthday);
    // five years for 21 yoe, any time after 16 for under age.
    const stauteOfLimitation: SafeDateTime = isOverTwentyOne ? fiveYearsAgo : sixteenthBirthdate;

    const isEndDateBeforeStatue: boolean = isSafeDateLater(stauteOfLimitation, endDate);

    return {
      presence: true,
      daterange: {
        requireYear: false,
        earliest: isEndDateBeforeStatue ? setToStartOfMonth(stauteOfLimitation).datetime : applicantBirthdate?.datetime,
        tooEarly: isEndDateBeforeStatue ? 'error.beforeDuration' : 'error.applicantMin',
        latest: DEFAULT_LATEST
      },
    };
  },
  NegativeImpactExplanation: (value, attributes) => {
    if (attributes?.HasNegativeImpact?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  }
};

export default substanceDrugsNegativeImpactValidator;
